<template>
  <ul class="kp-modular-menu">
    <logo></logo>
    <steps></steps>
    <model></model>
    <button-style></button-style>
    <advanced-config></advanced-config>
    <span class="sidebar_notify__icon"
      :class="{'notify_topbar_active': topBarConfig.user.ucode, 'is-loading': isLoading }">
      <div class="klickart-loader-container">
        <div class="klickart-loader"></div>
      </div>
      <i class="fa fa-check"></i>
      <div class="sidebar_notify__label">{{ isLoading ? $t('general.labels.saving') : 'OK' }}</div>
    </span>
  </ul>
</template>

<script>
import Logo from './types/Logo.vue';
import Steps from './types/Steps.vue';
import Model from './types/Model.vue';
import ButtonStyle from './types/Style.vue';
import AdvancedConfig from './types/AdvancedConfig.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    Logo,
    Steps,
    Model,
    ButtonStyle,
    AdvancedConfig,
  },
  computed: mapGetters({
    topBarConfig: 'topBar/config',
  }),
  mounted() {
    window.addEventListener('requestStart', () => {
      this.isLoading = true;
    });

    window.addEventListener('requestEnd', () => {
      this.isLoading = false;
    });
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?4e2bed43
 **/